import { INotificationTemplateDto } from "@kuika/kuika-cl-model";
import {
  SET_NEXT_CALLBACK_FUNCTION,
  SET_SHOW_MODAL,
  SET_UNSAVED_CHANGES,
  UnsavedChangesModalModuleActionTypes
} from "./types";

export const setShowModal = (
  showModal: boolean,
  nextTemplate: INotificationTemplateDto | null
): UnsavedChangesModalModuleActionTypes => {
  return {
    type: SET_SHOW_MODAL,
    meta: {
      params: {
        showModal,
        nextTemplate
      }
    }
  };
};

export const setUnsavedChanges = (hasUnsavedChanges: boolean): UnsavedChangesModalModuleActionTypes => {
  return {
    type: SET_UNSAVED_CHANGES,
    meta: {
      params: {
        hasUnsavedChanges
      }
    }
  };
};

export const setNextCallbackFunction = (nextCallback?: () => void): UnsavedChangesModalModuleActionTypes => {
  return {
    type: SET_NEXT_CALLBACK_FUNCTION,
    meta: {
      params: {
        nextCallback
      }
    }
  };
};

export type NotificationTemplateAction = typeof setShowModal | typeof setUnsavedChanges;
